// Countries of offline consultations and of the catalog sections (/pl/therapists...)
export const COUNTRY_CODES = "AD AE AL AM AR AT AU AZ BA BE BG BH BR BY CA CH CL CN CO CY CZ DE DK DZ EE EG ES FI FR GB GE GR HR HU ID IE IL IN IS IT JO JP KG KR KZ LB LI LT LU LV MA MC MD ME MK MT MX MY NL NO NZ PE PH PK PL PT QA RO RS SA SE SG SI SK SM TH TJ TM TN TR TW UA US UZ VN ZA".split(" ");

export function countryName(code) {
  try {
    return new Intl.DisplayNames(["uk"], { type: "region" }).of(code) || code;
  } catch (e) {
    return code;
  }
}

// countries by name in Ukrainian; Ukraine and the neighbours first
export function countryOptions() {
  const first = ["UA", "PL", "DE", "CZ", "SK", "RO", "MD", "LT", "LV", "EE"];
  const rest = COUNTRY_CODES.filter((code) => !first.includes(code))
    .map((code) => ({ code, name: countryName(code) }))
    .sort((a, b) => a.name.localeCompare(b.name, "uk"));
  return first.map((code) => ({ code, name: countryName(code) })).concat(rest);
}
